module.exports = __webpack_public_path__ + "wilkinson-small.jpg?e27b2c4d094e86d211053abbdf73b834";